import { computed, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { Feature } from 'src/app/features/feature-management/models';
import { FeatureManagementService } from 'src/app/features/feature-management/services';
import { PackageUsersSelectors } from 'src/app/features/package-users';
import { PackagesSelectors, ProductType } from 'src/app/features/packages';
import { CheckInSelectors } from 'src/app/features/check-in/store';

@Injectable({
  providedIn: 'root',
})
export class SessionHandoffService {
  private readonly productType = this.store.selectSignal(PackagesSelectors.getProductType);
  private readonly packageUsers = this.store.selectSignal(PackageUsersSelectors.getPackageUsers);
  private readonly isSigningAgent = this.store.selectSignal(
    PackageUsersSelectors.getIsSigningAgent
  );
  private readonly isRejoining = this.store.selectSignal(CheckInSelectors.isRejoining);

  readonly isSessionHandoffEnabled = computed(() => {
    // Revert to old welcome screen for rejoins for now - there are too many edge cases to handle in the meantime.
    if (this.isRejoining()) {
      return false;
    }

    const useSigningJoinCodes = this.featureManagementService.getIsFeatureEnabledWithCaching(
      Feature.UseSigningJoinCodes
    );
    return (
      useSigningJoinCodes &&
      this.productType() === ProductType.RemoteSigning &&
      !this.isSigningAgent() &&
      !this.packageUsers().some((user) => user.userRoleCode === 'NBTH')
    );
  });

  constructor(
    private readonly featureManagementService: FeatureManagementService,
    private readonly store: Store
  ) {}
}
